import { Link, LinkProps, Skeleton } from '@mui/material';
import { RouteLink, Types } from '@scorenco/core';

import { RouteKey } from '@/routes';

type EventCompetitionNameProps = LinkProps & {
  event?: Types.Competitions_Event_Detail;
  tournamentUrl?: string;
};

export const EventCompetitionName = ({
  event,
  tournamentUrl,
  ...rest
}: EventCompetitionNameProps) => {
  const sportSlug = event?.sport?.slug;
  const roundId = event?.round?.id;
  const competitionId = event?.round?.competition?.id;
  const competitionSlug = event?.round?.competition?.slug;

  return (
    <Link
      component={RouteLink}
      href={
        tournamentUrl ||
        (sportSlug && competitionId && competitionSlug
          ? {
              routeKey: RouteKey.Competition,
              params: {
                sport: sportSlug,
                competition:
                  competitionSlug + '-' + competitionId.toString(36) || '',
                r: roundId,
              },
            }
          : undefined)
      }
      textAlign="center"
      {...rest}
    >
      {[event?.level_name, event?.round?.name].filter(Boolean).join(' - ') || (
        <Skeleton width={250} />
      )}
    </Link>
  );
};
